import { render } from "./AlertBox.vue?vue&type=template&id=337161bc"
import script from "./AlertBox.vue?vue&type=script&lang=js"
export * from "./AlertBox.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_adm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__